<div class="navbar">
  <div class="nav-content">
    <div class="nav-logo-wrapper">
      <img
        (click)="toHome()"
        class="logo"
        style="cursor: pointer"
        src="assets/icons/Logo.JPG"
        alt=""
      />
    </div>

    <div class="nav-main-heading">
      <div class="main-nav-link" style="text-align: center">
        <a
          (click)="toHome()"
          class="archer-heading"
          style="
            margin-bottom: 10px;
            color: white;
            display: block;
            cursor: pointer;
          "
        >
          भारतीय तीरंदाजी संघ
        </a>
        <a
          style="cursor: pointer; display: block"
          (click)="toHome()"
          class="archer-heading"
          >Archery Association of India</a
        >
      </div>
      <div class="logs-options">
        <p (click)="login()" class="log-links">Login</p>
        <p (click)="register()" class="log-links">Sign up</p>
      </div>
    </div>

    <div class="nav-links">
      <ul class="nav">
        <li class="nav_item">
          <a class="simple-link" routerLink="/archers">Registered Archer</a>
        </li>
        <div class="dropdown">
          <a class="dropbtn">About Us</a>
          <div class="dropdown-content">
            <a routerLink="/about">About us</a>
            <a routerLink="/history">History</a>
          </div>
        </div>
        <div class="dropdown">
          <a class="dropbtn">Organization</a>
          <div class="dropdown-content">
            <a routerLink="/member-unit">Member units</a>
            <a routerLink="/gcArchers">Archers nominated for GC</a>
            <a routerLink="/executive">Executive committees</a>
            <a routerLink="/commities">Committees</a>            
            <a routerLink="/judges">Judges</a>
            
            <!-- <a href="#">Sponsors</a> -->
          </div>
        </div>
        <li class="nav_item">
          <a class="simple-link" routerLink="/achievements">Achievements</a>
        </li>
        <li class="nav_item">
          <a class="simple-link" routerLink="/calendar">Calendar</a>
        </li>

        <div class="dropdown">
          <a class="dropbtn">Events</a>
          <div class="dropdown-content">
            <p class="nav-p">1.Results</p>
            <a routerLink="/results">(i) Result</a>
            <a routerLink="/records">(ii) Records</a>

            <a routerLink="/events"><p class="nav-p">2.Upcoming Events</p></a> 
            
          </div>
        </div>
        <li class="nav_item">
          <a routerLink="/rules" class="simple-link">Rules</a>
        </li>
        <!-- <li class="nav_item">
          <a class="simple-link" routerLink="/news">News</a>
        </li> -->
        <li class="nav_item">
          <a class="simple-link" routerLink="/annualAccounts"
            >Annual accounts</a
          >
        </li>

        <li class="nav_item">
          <a class="simple-link" routerLink="/compliance"
            >Government <br/> Compliance</a
          >
        </li>
        <!-- <li class="nav_item">
          <a class="simple-link" routerLink="/goverment-section"
            >Government <br/>Sanction Orders</a
          >
        </li> -->
        <div class="dropdown">
          <a class="dropbtn">Government <br/>Sanction Orders</a>
          <div class="dropdown-content">
            <a routerLink="/goverment-section-international">International</a>
            <a routerLink="/goverment-section-national">National</a>
            <a routerLink="/goverment-section-coaching-camp">Coaching Camp</a>
            <a routerLink="/goverment-section-khelo-india">Khelo India</a>
            <a routerLink="/goverment-section-miscellaneous">Miscellaneous</a>

          </div>
        </div>
      </ul>
    </div>
    <div class="flow-wrap">
      <marquee class="flow" behavior="scroll" direction="left">
        <span
          *ngFor="let data of banners"
          style="margin-right: 50px; font-family: banner"
        >
          {{ data?.title }}
        </span>
      </marquee>
    </div>
  </div>
</div>

<div class="sideMenu">
  <div style="display: flex; padding: 10px">
    <img
      (click)="openT()"
      src="assets/icons/menu.png"
      class="toggle-menu"
      alt=""
    />
    <img
      (click)="toHome()"
      style="
        cursor: pointer;
        height: 25px;
        border-radius: 50%;
        margin-right: 10px;
        margin-left: 10px;
      "
      src="assets/icons/Logo.JPG"
      alt=""
    />
    <h2>Archery Association of India</h2>
  </div>
</div>

<div *ngIf="menuOpen" class="toggle-content">
  <div
    style="justify-content: space-between; display: flex; padding: 15px 15px"
  >
    <img
      (click)="toHome()"
      style="cursor: pointer; height: 55px; border-radius: 50%"
      src="assets/icons/Logo.JPG"
      alt=""
    />
    <img
      style="height: 15px"
      (click)="closeT()"
      src="assets/icons/close.png"
      class="toggle-menu"
      alt=""
    />
  </div>

  <ul>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/archers">Registered Archer</a>
    </li>

    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/executive">Executive committees</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/judges">Judges</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/member-unit">Members units</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/commities">Committees</a>
    </li>

    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/achievements">Achievements</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/calendar">Calendar</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/results">Results</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/records">Results</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a routerLink="/rules" class="simple-link">Rules</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/news">News</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/events">Events</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/annualAccounts">Annual accounts</a>
    </li>
    <li (click)="closeT()" class="nav_item">
      <a class="simple-link" routerLink="/compliance">Government Compliance</a>
    </li>
  </ul>

  <div
    style="
      display: flex;
      padding: 20px 15px;
      color: white;
      border-left: 1px solid #787fd4;
    "
  >
    <p (click)="login()" class="log-links-mobile">Login</p>
    <p (click)="register()" class="log-links-mobile">Sign up</p>
  </div>
</div>

<div class="outlet-area">
  <router-outlet> </router-outlet>

  <section class="logoMarqueeSection webOnly" style="margin-bottom: 30px">
    <div class="container" id="logoMarqueeSection">
      <div class="default-content-container flex items-center">
        <div
          class="default-content-container-inner marquee-wrapper relative overflow-hidden inline-block"
        >
          <div class="marquee" style="animation-duration: 57s">
            <a
              *ngFor="let data of LogoData"
              [href]="data?.logoLink"
              target="_blank"
              ><img
                [src]="global?.basePathImage + data?.logoPhoto"
                title=""
                class="marqueelogo"
                style="width: auto; max-width: none"
            /></a>
          </div>
          <div class="marquee" style="animation-duration: 57s">
            <a
              *ngFor="let data of LogoData"
              [href]="data?.logoLink"
              target="_blank"
              ><img
                [src]="global?.basePathImage + data?.logoPhoto"
                title=""
                class="marqueelogo"
                style="width: auto; max-width: none"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="slider mobileOnly">
    <ul>
      <li *ngFor="let data of LogoData">
        <a [href]="data?.logoLink" target="_blank">
          <img
            class="logo-img"
            [src]="global?.basePathImage + data?.logoPhoto"
            alt=""
          />
        </a>
      </li>
    </ul>
  </div>

  <div class="footer">
    <div class="footer-top">
      <div *ngIf="HtmlData" class="Committees" style="color: white;font-family: Regular;">
        <div [innerHTML]="HtmlData"></div>
      </div>

      <!-- <div class="ui-g-5 ui-md-5 ui-sm-12">
        <h2>Archery Association of India</h2>
        <p>
          Near Archery Ground, Gate No.2, Yamuna Sports Complex, Surajmal Vihar,
          Delhi-92 <br />
          Ph.+91-11-22146057;
          <br />
          Support Email id : supportaaimembership20@gmail.com; Website:
          indian.archery@yahoo.in
        </p>
      </div>
      <div class="ui-g-3 ui-md-3 ui-sm-6">
        <h2>Useful links</h2>
        <a href="">Circular</a>
        <a href="">AAI Election</a>
        <a href="">Forms</a>
      </div>
      <div class="ui-g-4 ui-md-4 ui-sm-6">
        <a href="">Home</a>
        <a routerLink="/about">About us</a>
        <a routerLink="/archers">Archers</a>
        <a routerLink="/results">Results</a>

      </div>
      <div class="ui-g-4"></div> -->
    </div>
    <div class="footer-bottom">Copyright © 2015 - All Rights Reserved.</div>
  </div>
</div>
